import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Divider, IconButton, LinearProgress, Typography, styled } from '@mui/material';

import { useRegistration } from '../contexts/RegistrationContext.js';

import Logo from './Logo.js';
import RegistrationStepper from './RegistrationStepper.js';
import Success from './steps/Success.js';

const RegistrationTitle = styled(Typography)({
  color: '#000',
  fontFamily: 'Red Hat Display, sans-serif',
  fontSize: 20,
  fontWeight: 700,
  letterSpacing: '0.15px',
  lineHeight: '24px',
  textAlign: 'center',
});

const Card = styled(Box)({
  alignItems: 'center',
  backgroundColor: 'white',
  border: '1px solid #E1E4E8',
  boxShadow: '0 0 20px -12px rgba(0, 0, 0, 0.12)',
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  padding: 24,
  position: 'relative',
  width: 450,
});

const HeaderContainer = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  position: 'relative',
  width: '100%',
});

const BackButton = styled(IconButton)({
  color: '#000',
  left: 0,
  position: 'absolute',
});

const LogoContainer = styled(Box)({
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
});

const RegistrationCard = () => {
  const { currentStep, isLoading, isRegistrationComplete, setCurrentStep, setError } =
    useRegistration();

  const handleBack = () => {
    if (currentStep > 0) {
      setError(undefined);
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <Card>
      {isLoading && (
        <LinearProgress sx={{ left: 0, position: 'absolute', right: 0, top: 0, zIndex: 10 }} />
      )}

      <HeaderContainer>
        {currentStep > 0 && !isRegistrationComplete && (
          <BackButton onClick={handleBack}>
            <ArrowBackIcon color="primary" />
          </BackButton>
        )}
        <LogoContainer>
          <Logo sx={{ height: 58, width: 256 }} />
        </LogoContainer>
      </HeaderContainer>

      <Divider sx={{ width: '100%' }} />

      {isRegistrationComplete ? (
        <Success />
      ) : (
        <>
          <RegistrationTitle>Complete your registration</RegistrationTitle>
          <RegistrationStepper />
        </>
      )}
    </Card>
  );
};

export default RegistrationCard;
